module.exports = __webpack_public_path__ + "img/camera.3cd36366.svg";